<template>
  <div v-if="showDuvetCollection() && isDuvetCollection">
    <div :class="$style.duvet_collection">
      <div :class="$style.duvet_collection_banner" @click="isDuvetCollectionBannerModalVisible = true">
        <div :class="$style.duvet_collection_inner">
          <div :class="$style.duvet_collection_inner_text_1">不要な羽毛布団はありませんか？</div>
          <div :class="$style.duvet_collection_inner_text_2">無料で布団を回収します</div>
          <div :class="$style.duvet_collection_inner_text_3">詳細を見る +</div>
        </div>
        <AtomsConsumerImage
          src="/images/components/product/duvet_collection_guidance_3.png"
          :width="40"
          :class="$style.recycling"
        />
      </div>
    </div>
    <OrderDuvetCollectionModal
      v-model:visible="isDuvetCollectionBannerModalVisible"
      :show-button="false"
      @cancel="isDuvetCollectionBannerModalVisible = false"
    />
  </div>
</template>

<script setup lang="ts">
import { useDuvetCollection } from "~/composables/useDuvetCollection"

const { showDuvetCollection } = useDuvetCollection()

interface Props {
  isDuvetCollection: boolean
}
defineProps<Props>()

const isDuvetCollectionBannerModalVisible = ref<boolean>(false)
</script>

<style scoped module lang="scss">
.duvet_collection {
  display: flex;
  justify-content: center;
  width: 100%;

  .duvet_collection_banner {
    width: 100%;
    max-width: 800px;
    border: none;
    border-radius: 0.25rem;
    background-image: url("/images/components/product/duvet_collection_bg.png");
    background-size: 100%;
    background-position: 50%;
    padding: 32px 0 32px 20px;
    min-height: 120px;
    position: relative;
    cursor: pointer;

    .duvet_collection_inner {
      .duvet_collection_inner_text_1 {
        color: $primary-100;
        font-size: $font-size-14;
        font-weight: bold;
      }

      .duvet_collection_inner_text_2 {
        color: #18181b;
        font-size: $font-size-16;
        font-weight: bold;
      }

      .duvet_collection_inner_text_3 {
        color: $primary-100;
        font-size: $font-size-12;
        text-decoration: underline;
      }
    }

    .recycling {
      position: absolute;
      top: 15%;
      right: 15%;
    }
  }
}
</style>
